import React from 'react';
import theme from '@/styles/theme';
import { SVGIconType } from '@/components/icons/svg-icon-types';

export interface CaretDownIconProps extends SVGIconType {}

const CaretDownIcon = ({ width = 16, color, ...props }: CaretDownIconProps) => {
  let defaultColor = color ? theme.color[color] : 'black';
  let height = props.height || width;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3538 6.35403L8.35375 11.354C8.30732 11.4005 8.25217 11.4374 8.19147 11.4626C8.13077 11.4877 8.06571 11.5007 8 11.5007C7.9343 11.5007 7.86923 11.4877 7.80853 11.4626C7.74783 11.4374 7.69269 11.4005 7.64625 11.354L2.64625 6.35403C2.55243 6.26021 2.49973 6.13296 2.49973 6.00028C2.49973 5.8676 2.55243 5.74035 2.64625 5.64653C2.74007 5.55271 2.86732 5.5 3 5.5C3.13269 5.5 3.25993 5.55271 3.35375 5.64653L8 10.2934L12.6463 5.64653C12.6927 5.60007 12.7479 5.56322 12.8086 5.53808C12.8693 5.51294 12.9343 5.5 13 5.5C13.0657 5.5 13.1308 5.51294 13.1915 5.53808C13.2521 5.56322 13.3073 5.60007 13.3538 5.64653C13.4002 5.69298 13.4371 5.74813 13.4622 5.80883C13.4873 5.86953 13.5003 5.93458 13.5003 6.00028C13.5003 6.06598 13.4873 6.13103 13.4622 6.19173C13.4371 6.25242 13.4002 6.30757 13.3538 6.35403Z"
        fill={defaultColor}
      />
    </svg>
  );
};

export default CaretDownIcon;
